const schema = [
        ['machineName'],
        ['displayName'],
        ['description'],
        ['permissions'],
];

export default schema;
